import React, {useEffect, useState} from 'react';
// import ProductGallerySlide from './ProductGallerySlide';
// import ProductGallerySlideVideo from './ProductGallerySlideVideo';
import ProductGalleryStore from './flux/ProductGalleryStore';

export default function ProductGallery(props) {
  const json = props.json;
  // const [variantName, setVariantName] = useState(ProductGalleryStore.getVariantTitle());
  // const [variantID, setVariantID] = useState(ProductGalleryStore.getVariantID());
  const [mediaArray, setMediaArray] = useState([]);
  const [selectedMediaID, setSelectedMediaID] = useState(false);

  useEffect(() => {
    const emitter1 = ProductGalleryStore.addListener('variant', () => {
      // client switched variant.
      setMediaArray(ProductGalleryStore.getMediaArray());
      setSelectedMediaID(ProductGalleryStore.getSelectedID());
    });
    return () => { emitter1.remove(); }
  });

  useEffect(() => {
    const emitter2 = ProductGalleryStore.addListener('selectedID', () => {
      // change selected media ID.
      setSelectedMediaID(ProductGalleryStore.getSelectedID());
    });
    return () => { emitter2.remove(); }
  });
  

  useEffect(() => {
    if (json && json.media) {
      ProductGalleryStore.setFullMediaArray(json);
      ProductGalleryStore.setVariant(json.variant);
    }
  }, [json]);

  function selectMedia(media) {
    // ProductGalleryStore.setSelectedID(media.id);
    ProductGalleryStore.setModalMediaID(media.id);
  }

  function playButton() {
    return (
      <i className="fa-solid fa-play" />
    )
  }

  function renderSlide(media) {
    return (
      <li className="slide">
        <img
          src={media.thumb}
          className="thumb"
          alt="media.alt"
        />
        {media.media_type === 'external_video' || media.media_type === 'video' ? playButton() : ''}
        {/* {media.media_type === 'image' ? <ProductGallerySlide media={media} /> : ''}
        {media.media_type === 'video' ? <ProductGallerySlideVideo media={media} /> : ''}
        {media.media_type === 'external_video' ? <ProductGallerySlideVideo media={media} /> : ''} */}
        <button className="enlarge" title={media.alt} onClick={(() => { selectMedia(media) })}>
          <i className="fa-solid fa-magnifying-glass-plus" />
          <span className="hidden">
            {media.media_type === 'external_video' || media.media_type === 'video' ? 'enlarge video' : 'enlarge image'}
          </span>
        </button>
      </li>
    )
  }

  return (
    <ul className="product-media-gallery">      
      {mediaArray.map((media) => {
        if (media.id === selectedMediaID) {
          return renderSlide(media);
        }
        return false;
      })}
      {mediaArray.map((media) => {
        if (media.id !== selectedMediaID) {
          return renderSlide(media);
        }
        return false;
      })}
   </ul>
  )
}